module.exports = __webpack_public_path__ + "img/defaultCoinIco.f49304ef.png";